import { EnergyHeatmap } from '../../../../features/Charts/Heatmap';
import { MeterMedium, MeterType } from '../../../../services/energyHeatmap';

const Heatmap = (props: { start: Date, end: Date, valueFactor?: number, dimension?: string }) => {

    const mediumFilter: MeterMedium[] = [MeterMedium.ColdMeter, MeterMedium.ElectricityMeter, MeterMedium.HeatMeter]
    const typeFilter: MeterType[] = [MeterType.FeedIn];
    return (
        <EnergyHeatmap start={props.start} end={props.end} dimension={props.dimension} valueFactor={props.valueFactor} mediumsFilters={mediumFilter} typeFilters={typeFilter}></EnergyHeatmap>
    )
}

export default Heatmap;
